<template>
	<tr :style="{backgroundColor: passedMarketIndex % 2 === 0 ? '#f8f9fa' : '#ffffff',
							color: listing.isFrozen === true ?  '#007bff' : '#212529'}" >
		<!--only render the seller identifier one time for all listings and all commands-->
		<td
				v-if="passedSellerIndex === 0 && passedConditionIndex === 0 && passedListingsIndex === 0"
				:rowspan="passedTotalRowSpan"
				class="market-cell"
		>
			{{ passedMarketData.market.name}}
			<a @click="openInNewTab(buildLink(passedMarketData.mdsMarketIdentifier))" onmouseover style="cursor: pointer;">
				<img
					:src="`/images/marketicons/${passedMarketData?.marketId}.gif`"
					border="0" width="16" height="16"
					alt=""/>
			</a>
		</td>
		<td :rowspan="passedTotalSellerRowSpan" v-if="passedConditionIndex === 0 && passedListingsIndex === 0" class="vert-align">{{ passedSeller }}</td>
		<td class="vert-align">{{ listing.quantity }}</td>
		<td class="vert-align">{{ getConditionName(listing)}}</td>
		<td class="vert-align">{{ truncateName(listing.vendorName)}}</td>
		<!--Seller -->
		<td v-if="passedMmData?.seller">
						<span class="mb-0">
							{{ formatePrice(passedMmData?.seller, passedMarketData.country.currencyIso) }}
							</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
							<br> {{ convertPriceToEuro(passedMmData?.seller, passedMarketData?.country.currencyToEuro)}}</span>
		</td >
		<td v-else>-</td>
		<!--buyBoxPrice -->
		<td v-if="passedMmData?.competitivePriceThreshold || passedMmData?.priceStar">
						<span class="mb-0">
							{{ formatePrice((passedMarketData.mdsMarketIdentifier === "BOL-NL" ? passedMmData?.priceStar : passedMmData?.competitivePriceThreshold), passedMarketData?.country.currencyIso) }}
						</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
						<br> {{ convertPriceToEuro((passedMarketData.mdsMarketIdentifier === "BOL-NL" ? passedMmData?.priceStar : passedMmData?.competitivePriceThreshold), passedMarketData?.country.currencyToEuro)}}</span>
		</td >
		<td v-else>-</td>
		<!--FBA -->
		<td v-if="passedMmData?.market">
						<span class="mb-0">
							{{ formatePrice(passedMmData?.market, passedMarketData.country.currencyIso) }}
						</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
						<br> {{ convertPriceToEuro(passedMmData?.market, passedMarketData.country.currencyToEuro)}}</span>
		</td >
		<td v-else>-</td>
		<!--minimumPrice -->
		<td v-if="listing.minimumPrice">
			<span class="mb-0">{{ formatePrice(listing.minimumPrice, passedMarketData.country.currencyIso, listing.shippingCost) }}</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
						<br> {{ convertPriceToEuro(listing.minimumPrice, passedMarketData.country.currencyToEuro, listing.shippingCost)}}</span>
		</td>
		<td v-else>-</td>
		<!--sellingPrice -->
		<td v-if="listing.sellingPrice">
						<span class="mb-0">
							{{  formatePrice(listing.sellingPrice, passedMarketData.country.currencyIso, listing.shippingCost)}}
						</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
							<br> {{ convertPriceToEuro(listing.sellingPrice, passedMarketData.country.currencyToEuro, listing.shippingCost)}}
						</span>

		</td>
		<td v-else>-</td>
		<!--maximumPrice -->
		<td v-if="listing.maximumPrice">
			<span class="mb-0">{{ formatePrice(listing.maximumPrice, passedMarketData.country.currencyIso, listing.shippingCost) }}</span>
			<span v-if="passedMarketData.country.currencyIso !== 'EUR'">
							<br> {{ convertPriceToEuro(listing.maximumPrice, passedMarketData.country.currencyToEuro, listing.shippingCost)}}
						</span>
		</td>
		<td v-else>-</td>
		<!--status -->
		<td titel="BP = BestPrice" class="align-middle">
			{{ listing.isBest ? "BP" : ""}}
				<b-btn size="sm"  v-if="listing?.isFrozen == true" title="unfreeze Listing" @click="freezeListing()" variant="danger"><i class="bi bi-snow"></i></b-btn>
				<b-btn size="sm"  v-else title="freeze Listing" @click="freezeListing()"  ><i class="bi bi-snow"></i></b-btn>

			<b-btn size="sm" class="ml-2" title="show timestamps" @click="showTimestampsModal = true"  ><i class="bi bi-info-circle-fill"></i></b-btn>
			<b-modal
					v-model="showTimestampsModal"
					title="Listing Timestamps"
					size="sm"
					hide-footer
					hide-header
			>
				Erstellt:       {{ moment(listing.createdAt).format('DD.MM.YYYY HH:mm:ss') }} <br>
				letztes Update: {{ moment(listing.updatedAt).format('DD.MM.YYYY HH:mm:ss') }}
			</b-modal>
		</td>
		<modal-error-component v-model="modalError"></modal-error-component>
	</tr>
</template>

<script>

import ModalErrorComponent from "../../../ModalErrorComponent.vue";

export default {
	components: {ModalErrorComponent},
	props: {
		passedListing: {
			type: Object,
			required: true,
		},
		passedSeller: {
			type: String,
			required: true,
		},
		passedSellerIndex: {
			type: Number,
			required: true,
		},
		passedCondition: {
			type: String,
			required: true,
		},
		passedConditionIndex: {
			type: Number,
			required: true,
		},
		passedListingsIndex: {
			type: Number,
			required: true,
		},
		passedMarketData: {
			type: Object,
			required: true,
		},
		passedMmData: {
			type: Object,
		},
		passedTotalRowSpan: {
			type: Number,
			required: true,
		},
		passedTotalSellerRowSpan: {
			type: Number,
			required: true,
		},
		passedMarketIndex: {
			type: Number,
			required: true,
		},
		passedAsin: {
			type: String,
			required: true,
		},
		passedEan: {
			type: String,
			required: true,
		}
	},
	data() {
		return {
			listing: this.passedListing,
			latestCheckMarket: "",
			currentRowGroupIndex: 0,
			currencySymbols: {
				EUR: '€',   // Euro
				USD: '$',   // US Dollar
				GBP: '£',   // British Pound
				JPY: '¥',   // Japanese Yen
				CAD: 'CAD', // Canadian Dollar
				DKK: 'kr',  // Danish Krone
				PLN: 'zł',  // Polish Zloty
				SEK: 'kr',  // Swedish Krona
				NOK: 'kr',  // Norwegian Krone
				AUD: 'AUD', // Australian Dollar
				MXN: 'MXN', // Mexican Peso
				BRL: 'BRL', // Brazilian Real
				TRY: '₺',   // Turkish Lira
				SGD: 'SGD'  // Singapore Dollar
			},
			marketLinks: {
				"AMZ-AE": "https://www.amazon.ae/",
				"AMZ-AU": "https://www.amazon.com.au/",
				"AMZ-BR": "https://www.amazon.com.br/",
				"AMZ-CA": "https://www.amazon.ca/",
				"AMZ-DE": "https://www.amazon.de/",
				"AMZ-ES": "https://www.amazon.es/",
				"AMZ-FR": "https://www.amazon.fr/",
				"AMZ-IE": "https://www.amazon.ie/",
				"AMZ-IT": "https://www.amazon.it/",
				"AMZ-JP": "https://www.amazon.co.jp/",
				"AMZ-MX": "https://www.amazon.com.mx/",
				"AMZ-NL": "https://www.amazon.nl/",
				"AMZ-BE": "https://www.amazon.com.be/",
				"AMZ-PL": "https://www.amazon.pl/",
				"AMZ-SE": "https://www.amazon.se/",
				"AMZ-SG": "https://www.amazon.sg/",
				"AMZ-TR": "https://www.amazon.com.tr/",
				"AMZ-UK": "https://www.amazon.co.uk/",
				"AMZ-US": "https://www.amazon.com/",
				"BOL-NL": "https://www.bol.com/nl/s/?searchtext=",
				"CDC-FR": "https://www.cdiscount.com/search/10/", //ean.html
				"EPR-IT": "https://www.eprice.it/",
				"FNC-BE": "https://www.fr.fnac.be/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-ES": "https://www.fnac.es/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-FR": "https://www.fnac.com/SearchResult/ResultList.aspx?Search=", // ean
				"FNC-PT": "https://www.fnac.pt/SearchResult/ResultList.aspx?Search=", // ean
				"RAK-FR": "https://fr.shopping.rakuten.com/search/", // ean
				"RDC-FR": "https://www.rueducommerce.fr/",
				"REL-DE": "https://www.kaufland.de/s/?search_value=", //ean
				"WRT-ES": "https://www.worten.es/search?query=", //ean
				"WRT-PT": "https://www.worten.pt/search?query=", //ean
				"ALG-PL": "https://allegro.pl/listing?string=", //ean
				"WAL-US":"https://www.walmart.com/search?q=", // ean
				"KFL-SK": "https://www.kaufland.sk/s/?search_value=", //ean
				"KFL-CZ": "https://www.kaufland.cz/s/?search_value=", //ean
				"KFL-AT": "https://www.kaufland.at/s/?search_value=", //ean
			},
			allSellerIdentifiers: ['MUL', 'COS','WRM', 'LDD'],
			modalError: {
				show: false,
				message: '',
				error: null,
				title: ''
			},
			showTimestampsModal: false,
		};
	},
	methods: {
		freezeListing() {
			const payload = {
				marketIdentifier: this.passedMarketData.mdsMarketIdentifier,
				asin: this.passedAsin,
				freeze: !this.listing.isFrozen,
				condition: this.passedCondition,
				sellerIdentifier: this.passedSeller
			};
			axios.put("/ngps/listings/freeze", payload)
				.then(response => {
					console.log("freezeListing response", response);
						this.listing.isFrozen = !this.listing.isFrozen;
				})
				.catch(error => {
					console.log("freezeListing error", error);
					this.modalError = {
						show: true,
						message: 'Ein Fehler beim Einfrieren des Listings ist entstanden.',
						error: error,
						title: 'Freeze Listing Error'
					};
				});
		},
		getConditionName(listing) {
			// console.log(listing.mmData)
			if (listing.condition == 1) {
				return "N";
			} else if (listing.condition == 2 && listing.newAsUsed === false) {
				return "SH";
			} else if (listing.condition == 2 && listing.newAsUsed === true) {
				return "SF";
			}
		},
		formatePrice(price, currencyIso, ownShippingFee = 0) {
			if (price == null || currencyIso == null) return '-';

			const parsedPrice = Number(price);
			let parsedShipping = ownShippingFee == null ? 0 : Number(ownShippingFee);

			if (isNaN(parsedPrice) || isNaN(parsedShipping)) return '-';

			if(this.listing.isPrimeSuitable){
				parsedShipping = 0;
			}
			const total = parsedPrice + parsedShipping;
			return total.toFixed(2) + ' ' + (this.currencySymbols[currencyIso] || '');
		},
		convertPriceToEuro(price, conversionRate, ownShippingFee = 0,) {
			if (price == null || conversionRate == null) return '-';
			const parsedPrice = Number(price);
			let parsedShipping = ownShippingFee == null ? 0 : Number(ownShippingFee);

			if (isNaN(parsedPrice) || isNaN(parsedShipping)) return '-';

			if(this.listing.isPrimeSuitable){
				parsedShipping = 0;
			}
			const euroTotal = (parsedPrice + parsedShipping) * conversionRate;
			return euroTotal.toFixed(2) + ' €';
		},
		truncateName(name) {
			return name.length > 15 ? name.substring(0, 15) + '...' : name;
		},
		openInNewTab(url) {
			const win = window.open(url, "_blank");
			win.focus();
		},
		buildLink(marketIdentifier) {
			switch(marketIdentifier.substring(0, 3))
			{
				case "BOL": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "AMZ": return this.marketLinks[marketIdentifier] + 'dp/' + this.passedAsin;
				case "FNC":
				case "WRT":
				case "RAK":
				case "KFL":
				case "REL": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "CDC": return this.marketLinks[marketIdentifier] + this.passedEan + ".html";
				case "ALG": return this.marketLinks[marketIdentifier] + this.passedEan;
				case "WAL": return this.marketLinks[marketIdentifier] + this.passedEan;
				default:    return this.marketLinks[marketIdentifier] + this.passedAsin;
			}
		},
	},
}
</script>
<style scoped>
.market-cell {
	text-align: center;
	vertical-align: middle;
	font-weight: bold;
	border-right: 2px solid #ddd;
}
.vert-align{
	vertical-align: middle
}
</style>